// This is for the production site, which is hosted at https://angular.io
export const environment = {
  gaId: 'UA-80456300-1', // Production id
  production: true,
  mode: 'stable',
};
